<template>
    <div class="roleManager">
        <!--数据部分-->
        <div class="centerStructure">
            <!--检索条件-->
            <div class="searchBox">
                <span>角色名称：</span>
                <el-input
                    class="cname"
                    v-model.trim="searchRoleName"
                    placeholder="请输入名称"
                    clearable
                ></el-input>
                <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
                <el-button
                    type="primary"
                    @click="insertRole"
                    icon="el-icon-circle-plus-outline"
                    v-if="$root.$permissionMap.has('insertRole')"
                >添加</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                ref="singleTable"
                style="width: 100%"
                height="calc(100% - 84px)"
            >
                <el-table-column type="index" align="center" width="50"></el-table-column>
                <template v-for="item in tableTitle">
                    <el-table-column
                        :header-align="item.headerAlign"
                        :align="item.align"
                        :key="item.index"
                        :label="item.label"
                        :prop="item.prop"
                        :width="item.width"
                        :formatter="item.formatter"
                        v-if="item.prop != 'operation'"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="item.prop == 'operation'"
                        :label="item.label"
                        :key="item.prop"
                        header-align="center"
                        align="center"
                        :width="item.width"
                    >
                        <template slot-scope="scope">
                            <span class="tableicon" v-if="$root.$permissionMap.has('updateRole')">
                                <i @click="editRole(scope)" class="el-icon-edit"></i>
                            </span>
                            <span class="tableicon" v-if="$root.$permissionMap.has('deleteRole')">
                                <i @click="delRole(scope)" class="el-icon-delete"></i>
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="pagetotal"
            ></el-pagination>
        </div>
        <el-dialog
            :title="title"
            :visible.sync="opendiaflag"
            :close-on-click-modal="false"
            :modal-append-to-body="false"
            width="880px"
        >
            <div class="formbox">
                <el-form
                    :rules="rules"
                    :label-position="labelPosition"
                    :model="formLabelAlign"
                    label-width="100px"
                    ref="formLabelAlign"
                >
                    <div class="openbox">
                        <div class="part1">
                        <el-form-item label="角色名称：" prop="roleName">
                            <el-input
                                v-model.trim="formLabelAlign.roleName"
                                placeholder="请输入角色名称"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="启用：">
                            <el-radio-group v-model="formLabelAlign.enable">
                                <el-radio border :label="true" >是</el-radio>
                                <el-radio border :label="false" >否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="排序码：" prop="sortCode">
                            <el-input
                                v-model.trim="formLabelAlign.sortCode"
                                placeholder="请输入排序码"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="备注：" prop="remark">
                            <el-input
                                type="textarea"
                                :rows="3"
                                placeholder="请输入备注"
                                v-model.trim="formLabelAlign.remark"
                            ></el-input>
                        </el-form-item>
                    </div>

                    <div class="part2">
                        <tree
                            ref="tree"
                            title="权限设置"
                            placeholder="请输入检索内容"
                            :treeEdit="false"
                            node-key="id"
                            :showCheckbox="true"
                            :sourceData="sourceData"
                            :defExpandNode="defaultOpen"
                            :formatTreeData="jsonTree"
                            :strictly="false"
                            @checkNodeClick="mycheckNodeClick"
                            @freshTreeData="getModuleTree"
                        ></tree>
                    </div>

                    <div class="part3">
                        <el-table :data="menuTable" border height="500px">
                            <template v-for="item in tableTitleMenu">
                                <el-table-column
                                    :align="item.align"
                                    :key="item.index"
                                    :label="item.label"
                                    :prop="item.prop"
                                    :width="item.width"
                                    :formatter="item.formatter"
                                    v-if="item.prop != 'operation'"
                                    show-overflow-tooltip
                                ></el-table-column>
                                <el-table-column
                                    v-if="item.prop == 'operation'"
                                    :label="item.label"
                                    :key="item.prop"
                                    header-align="center"
                                    align="center"
                                    :width="item.width">
                                    <template slot-scope="scope">
                                        <span class="tableicon">
                                            <i @click="delet(scope.$index)" class="el-icon-delete"></i>
                                        </span>
                                    </template>
                                </el-table-column>
                            </template>
                        </el-table>
                    </div>
                </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="opendiaflag = false">取 消</el-button>
                <el-button type="primary" :loading=submitFlag @click="submitForm('formLabelAlign')">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Mixins } from "@/config/mixins/mixins";
import { $http } from "@/config/api/axios";
import Tree from "@/components/common/Tree";
import { IsNull } from "@/config/validate/common.js";

export default {
    name: "roleManager",
    mixins: [Mixins],
    components: {
        Tree,
    },
    data() {
        function enableFormat(row, column, cellValue, index) {
            if (cellValue) {
                cellValue = "是";
            } else {
                cellValue = "否";
            }
            return cellValue;
        }
        return {
            searchRoleName: "",
            title: "角色信息",
            opendiaflag: true,
            labelPosition: "right",
            formLabelAlign: {
                id: "",
                roleName: "",
                enable: true,
                sortCode: 1,
                remark: "",
                roleScheme: "",
            },
            rules: {
                roleName: [
                    {required: true, message: "请输入角色名称", trigger: "blur",},
                    {min: 0, max: 20, message: "长度不允许超过20个汉字或字符", trigger: "blur",},
                ],
                sortCode: [
                    {required: true, message: "请输入排序码", trigger: "blur"},
                    {pattern: /^\+?[1-9]{1}[0-9]{0,2}\d{0,0}$/, message: "只允许输入1-999的数字", trigger: "blur",}
                ],
                remark: [
                    {min: 0, max: 50, message: "长度不超过50个字符", trigger: "blur",},
                ],
            },
            roleSchemeFrom: [],
            sourceData: [],
            defaultOpen:[0],
            jsonTree: {
                id: "authorityId",
                label: "authorityName",
                pcode: "authorityParentCode",
                code: "authorityCode",
                type:"authorityType"
            },
            tableTitleMenu: [
                {prop: "moduleName", label: "常用菜单", width: "", align: "center", show: true},
                {prop: "operation", label: "操作", width: "60px", align: "center", show: true}
            ],
            menuTable: [],
            oldCheckedId:new Map(),
            submitFlag:false,
            tableData: [],
            tableTitle: [
                {prop: "operation", label: "操作", width: "100px", align: "center", show: true},
                {prop: "roleName", label: "角色名称", width: "", headerAlign: "center", align: "left", show: true},
                {prop: "roleModuleCollectName", label: "常用菜单", width: "", headerAlign: "center", align: "left", show: true},
                {prop: "enable", label: "启用", width: "60px", align: "center", show: true, formatter: enableFormat},
                {prop: "sortCode", label: "排序码", width: "80px", align: "center", show: true},
                {prop: "userName", label: "创建人", width: "100px", align: "center", show: true},
                {prop: "createTime", label: "创建时间", width: "160px", align: "center", show: true}
            ],
            //分页数据设置
            pageSize: 20, //条数
            pageNumber: 1,
            currentPage: 1, //页数
            pagetotal: 0, //总条数
            menuFlag:0,
        };
    },
    methods: {
        getModuleTree() {
          $http("get", "authority/listSelfModulePermission").then((result) => {
            if (result.status == "SUCCESS") {
                result.data.unshift({
                    authorityCode: "0",
                    authorityName: "所有权限",
                    authorityId: 0,
                    authorityParentCode: "-1",
                })
                this.sourceData = result.data;
            }else if(result.status == "NORESOURCES"){
                this.sourceData = [];
            }else{
                this.msgerror(result.message);
            }
          });
        },
        search() {
          this.handleCurrentChange(1);
        },
        getData() {
            let params = {}; 
            params.pageSize = this.pageSize;
            params.pageNumber = this.pageNumber;
            params.roleName = this.searchRoleName;
            $http("get", "role/listRoles", params).then((res) => {
                if(res.status == "SUCCESS"){
                    this.tableData = res.data;
                    this.pagetotal = res.count;
                }else if(res.status == "NORESOURCES"){
                    this.tableData = [];
                    this.pagetotal = 0;
                }else{
                    this.msgerror(res.message);
                }
            });
        },
        insertRole() {
            this.opendiaflag = true;
            this.$refs.tree.setCheckedKeys([]);
            //清空table
            this.menuTable = [];
            this.oldCheckedId = new Map();
            this.$refs.formLabelAlign.resetFields();
            this.formLabelAlign.id = "";
            this.formLabelAlign.enable = true;
        },  
        editRole(scope) {
            this.opendiaflag = true;
            this.$refs.tree.setCheckedKeys([]);
            //清空table
            this.menuTable = [];
            this.oldCheckedId = new Map();
            this.menuFlag = 0;
            this.$refs.formLabelAlign.resetFields();
            this.formLabelAlign.id = scope.row.id;
            this.formLabelAlign.roleName = scope.row.roleName;
            this.formLabelAlign.enable = scope.row.enable;
            this.formLabelAlign.sortCode = scope.row.sortCode;
            this.formLabelAlign.remark = scope.row.remark;
            //获取控制台方案
            let param = {roleId:scope.row.id};
            $http("get", "roleScheme/getRolesSchemeByRoleId", param).then((res) => {
                if (res.status == "SUCCESS") {
                    this.formLabelAlign.roleScheme = res.data.schemeId;
                }else if(res.status == "NORESOURCES"){
                    
                }else{
                    this.msgerror(res.message);
                }
            });
            //获取角色权限
            $http("get", "rolePermission/listRolesPermission", param).then((res) => {
                if (res.status == "SUCCESS") {
                    for (let i = 0; i < res.data.length; i++) {
                        let node = this.$refs.tree.getNode(res.data[i].permissionId);
                        if(node != null){
                            if (node.childNodes == null || node.childNodes.length <= 0) {
                                this.$refs.tree.setChecked(res.data[i].permissionId, true, true);
                            }
                        }
                    }
                    let newCheckedId = new Map();
                    let checkedNodes = this.$refs.tree.getCheckedNodes();
                    //当前选中模块节点
                    checkedNodes.forEach(item => {
                        if(item.id !== 0 && item.pcode !== '0' && item.type === 1){
                            newCheckedId.set(item.id,{
                                id:item.id,
                                name:item.label
                            });
                        }
                    });
                    this.oldCheckedId = newCheckedId;
                }else if(res.status == "NORESOURCES"){

                }else{
                    this.msgerror(res.message);
                }
                this.menuFlag++;
                this.menuVerification();
            });
            //获取常用菜单
            $http("get", "roleModuleCollect/listRoleModuleCollect", param).then((res) => {
                if (res.status == "SUCCESS") {
                    for (let i = 0; i < res.data.length; i++) {
                        let node = this.$refs.tree.getNode(res.data[i]);
                        if(node == null){
                            continue;
                        }
                        this.menuTable.push({
                            moduleId: node.data.id,
                            moduleName: node.data.label
                        });
                    }
                }else if(res.status == "NORESOURCES"){

                }else{
                    this.msgerror(res.message);
                }
                this.menuFlag++;
                this.menuVerification();
            });
        },
        menuVerification(){
            if(this.menuFlag >= 2){
                for(let i = this.menuTable.length - 1; i >= 0; i--){
                    if(!this.oldCheckedId.has(this.menuTable[i].moduleId)){
                        this.menuTable.splice(i,1);
                    }
                }
            }
        },
        delRole(scope) {
            this.$confirm("删除后不能恢复，确认要删除吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let params = {roleId: scope.row.id};
                $http("post", "role/deleteRole", params).then((res) => {
                    if (res.status == "SUCCESS") {
                        this.msgsuccess(res.message);
                        if (this.tableData.length == 1 && this.pageNumber > 1) {
                            this.pageNumber--;
                        }
                        this.getData();
                    } else {
                        this.msgerror(res.message);
                    }
                });
            }).catch(() => {});
        },
        submitForm(ref) {
            this.$refs[ref].validate((valid) => {
                if (valid) {
                    let checkedNodes = this.$refs.tree.getCheckedNodes();
                    let halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes();
                    if (halfCheckedNodes.length > 0) {
                        checkedNodes.push(...halfCheckedNodes);
                    }
                    let rolePermissionList = [];
                    checkedNodes.forEach(item => {
                        if (item.id !== 0) {
                            rolePermissionList.push({permissionId: item.id, typeId: item.type});
                        }
                    });
                    if(rolePermissionList.length <= 0){
                        this.msgwarning("请选择权限。");
                        return;
                    }
                    let moduleCollectList = [];
                    this.menuTable.forEach(item =>{
                        moduleCollectList.push(item.moduleId);
                    });

                    let params = {
                        id: this.formLabelAlign.id,
                        roleName: this.formLabelAlign.roleName,
                        enable: this.formLabelAlign.enable,
                        sortCode: this.formLabelAlign.sortCode,
                        remark: this.formLabelAlign.remark,
                        schemeId: this.formLabelAlign.roleScheme,
                        rolePermissionList:JSON.stringify(rolePermissionList),
                        moduleCollectList:JSON.stringify(moduleCollectList)
                    };
                    this.submitFlag = true;
                    if(IsNull(params.id)){
                        //新增
                        $http("post", "role/insertRole", params).then((res) => {
                            this.submitFlag = false;
                            if (res.status == "SUCCESS") {
                                this.opendiaflag = false;
                                this.msgsuccess(res.message);
                                this.getData();
                            } else {
                                this.msgerror(res.message);
                            }
                        });
                    }else{
                        //编辑
                        $http("post", "role/updateRole", params).then((res) => {
                            this.submitFlag = false;
                            if (res.status == "SUCCESS") {
                                this.opendiaflag = false;
                                this.msgsuccess(res.message);
                                this.getData();
                            } else {
                                this.msgerror(res.message);
                            }
                        });
                    }
                }
            });
        },
        handleSizeChange(val) {
          this.pageSize = val;
          this.handleCurrentChange(1);
        },
        handleCurrentChange(val) {
          this.currentPage = val;
          this.pageNumber = val;
          this.getData();
        },
        mycheckNodeClick(data, checked){
            let newList = []; 
            let newCheckedId = new Map();
            let checkedNodes = checked.checkedNodes;
            //当前选中模块节点
            checkedNodes.forEach(item => {
                if(item.id !== 0 && item.pcode !== '0' && item.type === 1){
                    newCheckedId.set(item.id,{
                        id:item.id,
                        name:item.label
                    });
                    newList.push(item.id);
                }
            });
            //去除多余节点
            for(let i = this.menuTable.length - 1; i >= 0; i--){
                if(!newCheckedId.has(this.menuTable[i].moduleId)){
                    this.menuTable.splice(i,1);
                }
            }
            //添加新增节点
            newList.forEach(item => {
                if(!this.oldCheckedId.has(item)){
                    this.menuTable.push({
                        moduleId: newCheckedId.get(item).id,
                        moduleName: newCheckedId.get(item).name
                    });
                }
            });
            this.oldCheckedId = newCheckedId;
        },
        delet(inx) {
          this.menuTable.splice(inx, 1);
        },
    },
    created() {
    },
    mounted() {
        this.getModuleTree();
        this.getData();
        this.$nextTick(()=>{
            this.opendiaflag = false;
        });
    },
};
</script>

<style lang="less">
.roleManager {
  position: relative;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;

  .formbox {
    margin-right: 20px;
    overflow: hidden;
    max-height: 750px;

    .part1 {
      width: 300px;

      .wh210 {
        width: 210px;
      }
    }
    .part2 {
      width: 240px;
      margin-left: 20px;
      border: 1px solid #ebeef5;
    }
    .part3 {
      width: 240px;
      margin-left: 20px;
    }

    .openbox {
      height: 500px;
      display: flex;

      .tree-box .overauto .el-tree {
        height: 400px;
        overflow-y: auto;
      }

      .el-table__body-wrapper {
        height: 400px;
        overflow-y: auto;
      }
    }
    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 20px;
    }
  }
}
</style>